module.exports = __webpack_public_path__ + "static/img/dgi_img_search.92b4749.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/downloadGuideIos/dgi_img_search.jpg
// module id = 1067
// module chunks = 1